module.exports = __webpack_public_path__ + "img/Speraker-College 1.bb52fc87.jpg";